var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 10.4173C14.7999 10.4173 16.6654 8.55184 16.6654 6.25065C16.6654 3.94946 14.7999 2.08398 12.4987 2.08398C10.1975 2.08398 8.33203 3.94946 8.33203 6.25065C8.33203 8.55184 10.1975 10.4173 12.4987 10.4173Z",
    stroke: "rgba(0,0,0,1)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8306 18.7513C20.8327 18.5805 20.8327 18.4065 20.8327 18.2305C20.8327 15.6419 17.1014 13.543 12.4993 13.543C7.89727 13.543 4.16602 15.6419 4.16602 18.2305C4.16602 20.819 4.16602 22.918 12.4993 22.918C14.8233 22.918 16.4993 22.7544 17.7077 22.4628",
    stroke: "rgba(0,0,0,1)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/Icon-user.1ab8b87b37b0a0e622cbd87bb88f635a.svg";
export { ForwardRef as ReactComponent };